import { useMachine } from '@xstate/react';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext, useState } from 'react';
import createMapOverlayMachine, {
  MapOverlayMachineService,
  MapOverlayMachineState,
} from './mapOverlayStateMachine';

export type MapOverlayMachineContextValue = {
  mapOverlayMachineState: MapOverlayMachineState;
  mapOverlayMachineService: MapOverlayMachineService;
};

type MapOverlayMachineProviderProps = {
  children: React.ReactNode;
};

export const MapOverlayContext =
  React.createContext<MapOverlayMachineContextValue | null>(null);

const MapOverlayMachineProvider: React.FC<MapOverlayMachineProviderProps> = ({
  children,
}: MapOverlayMachineProviderProps) => {
  const { actions } = useContext(AppStoreContext);

  const [mapOverlayMachine] = useState(() =>
    createMapOverlayMachine({
      actions,
    })
  );

  const [mapOverlayMachineState, , mapOverlayMachineService] =
    useMachine(mapOverlayMachine);

  return (
    <MapOverlayContext.Provider
      value={{ mapOverlayMachineState, mapOverlayMachineService }}
    >
      {children}
    </MapOverlayContext.Provider>
  );
};

export { MapOverlayMachineProvider };
